import { Link } from 'react-router-dom'
import { Col } from 'reactstrap'
import { Href } from '../../../../../utils/Constant'
import { useAuth } from '../../../../../hooks/useAuth'

const ProfileName = () => {
  const { user } = useAuth();

  // Obtener nombre del usuario
  const userName = user?.name || user?.email || 'Usuario';
  
  // Obtener rol del usuario
  const userRole = user?.role?.name || 'Usuario';

  return (
    <>
      <Col sm="12" lg="4" className="order-sm-0 order-xl-1">
        <div className="user-designation">
          <div className="title">
            <Link to={Href}>
              {userName}
            </Link>
          </div>
          <div className="desc">{userRole}</div>
        </div>
      </Col>
    </>
  )
}

export default ProfileName